import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';
import * as actions from '../../store/actions';

angular.module('webTools').controller('ProjectsCtrl', ['$scope', '$rootScope', '$routeParams', '$location', '$timeout', 'Columns', 'GridTools', 'MenuBuilder', 'Auth', 'ModalWindow', 'Project', 'Utility', '$ngRedux', 'File', 'Dialog',
	function ($scope, $rootScope, $routeParams, $location, $timeout, Columns, GridTools, MenuBuilder, Auth, ModalWindow, Project, Utility, $ngRedux, File, Dialog) {

		$scope.kendo = $scope.kendo || {};
		$scope.data = $scope.data || {};
		$rootScope.view = 'projects';
		$scope.selectedId = '';
		$scope.gridName = 'projectsGrid';

		$scope.detailsMargin = '-350px';

		if (!$routeParams.page) {
			$location.search('page', 1);
			window.history.replaceState({}, '', $location.url());
		}

		$scope.setWorkingFolder = function () {
			$rootScope.workingFolder = $routeParams.folder ? $routeParams.folder : 'Projects';
			if ($routeParams.project) { $rootScope.workingFolder = $routeParams.project; }
		}

		if ($routeParams.linkError) {
			ModalWindow.openNotification('The project or folder you are trying to access does not exist <br/> or you do not have the permissions required to view it.');
			$location.search('linkError', null)
		}

		/* eslint-disable  no-useless-escape */
		$scope.currentLocation = $location.url().replace(/page\=\d+/g, '');
		/* eslint-enable  no-useless-escape */

		$scope.breadcrumb = [{ breadcrumbName: 'Projects', path: '/projects?folder=Projects', pathId: 'Projects' }];

		$scope.nodeSelect = function (e) {

			var node = e.sender.dataItem(e.node);

			if (node.Folder === '0') {
				$location.search({ folder: node.id, page: 1 });
			} else {
				$location.search({ project: node.id, page: 1 });
			}
		};

		$scope.getColumns = function () {
			if ($routeParams.project) {
				return Columns.getProjectDocumentColums($rootScope.workingFolder);
			} else {
				return Columns.getProjectColumns($rootScope.workingFolder);
			}
		};

		$scope.projectsGridOptions = {
			loadOnInit: true,
			mainGrid: true,
			allowRowSelect: true,
			allowMultiselect: false,
			allowColumnState: true,
			allowSelectFolders: false,
			enableContextMenu: true,
			columnMenu: true,
			sortable: true,
			resizable: true,
			reorderable: true,
			scrollable: true,
			responsive: true,
			pageable: {
				info: true,
				refresh: false
			}
		};

		$scope.setGridOptions = function () {

			if ($routeParams.project) {
				$scope.projectsGridOptions.allowMultiselect = true;
				return 'api/Projects/GetFiles'
			} else {
				$scope.projectsGridOptions.allowMultiselect = false;
				return 'api/Projects/GetProjects'
			}
		}

		$scope.setWorkingFolder();
		$scope.setGridOptions();

		$scope.projectsData = {
			transport: {
				read: {
					url: $scope.setGridOptions(),
					contentType: 'application/json',
					dataType: 'json'
				},
				parameterMap: function (data, operation) {

					if (data.sort && data.sort.length > 0) {
						const sort = { sortField: data.sort[0].field, sortDirection: data.sort[0].dir };
						
						if (operation === 'read') { delete data.sort; data = $.extend(sort, data); }
					}

					data = $.extend({ folderID: $rootScope.workingFolder }, data);

					return data;
				}
			},
			schema: {
				data: function (response) {
					Auth.setPermissions(response.Permissions);
					var path = response.Path;
					$scope.$apply(() => {
						switch ($rootScope.workingFolder.toLowerCase()) {
							default:
								let pathCopy = _.cloneDeep(path);

								pathCopy.forEach(p => {
									p.pathId = p.path;
									p.path = `/projects?folder=${p.path}`;
								})

								const { pathId: workingFolderId, breadcrumbName: workingFolderName } = _.last(pathCopy);
								$ngRedux.dispatch(actions.setWorkingFolder(workingFolderId, workingFolderName, 'projects'));

								$scope.breadcrumb = pathCopy;
								break;
						}
					})
					return response.Data;
				},
				total: 'TotalRows'
			},
			serverPaging: true,
			serverSorting: true,
			pageSize: 50,
			page: 1
		};

		$scope.$on('$routeUpdate', function (e, data) {
			$scope.menuOptions = [];
			/* eslint-disable  no-useless-escape */
			if ($scope.currentLocation === $location.url().replace(/page\=\d+/g, '')) {
				$scope.closeDetailsPane();
			} else {
				$scope.setWorkingFolder();
				$scope.projectsData.transport.read.url = $scope.setGridOptions();

				$scope.currentPage = data.params.page || 1;

				$scope.closeDetailsPane();
				if ($scope.data.workingFolder === 'Projects') { $scope.kendo.expandNode(); }
				$scope.selectedId = '';
				$scope.$broadcast('reloadGrid');
			}

			$scope.currentLocation = $location.url().replace(/page\=\d+/g, '');
			/* eslint-enable  no-useless-escape */
		});

		$scope.selectedId = '';

		$scope.$on('gridFolderLinkClicked', function (e, data) {
			$scope.$apply(function () { $location.search({ folder: GridTools.getObjectFromGrid(data, $scope.kendo[$scope.gridName]._data).ID, page: 1 }); });
		})

		$scope.$on('gridProjectLinkClicked', function (e, data) {
			$scope.$apply(function () { $location.search({ project: GridTools.getObjectFromGrid(data, $scope.kendo[$scope.gridName]._data).ID, page: 1 }); });
		})

		$scope.detailsPaneIsOpen = false;
		$scope.selectedObject = {};
		
		$scope.$on('gridItemSelected', function (e, data) {

			var wtObject = GridTools.getObjectFromGrid(data.id, $scope.kendo[$scope.gridName]._data);

			if(data.openDetails) {
				if (!$scope.detailsPaneIsOpen) {
					angular.element('#details-pane').css({ 'display': 'block' })
					$timeout(() => angular.element('#details-pane').css({ 'margin-right': 0 }), 100)
					$scope.detailsPaneIsOpen = true;
					$scope.selectedObject = wtObject;
				} else {
					if (data.id !== wtObject.ID && $scope.detailsPaneIsOpen) {
						$scope.selectedObject = wtObject;
					}
				}
			} else {
				if (data.id !== wtObject.ID && $scope.detailsPaneIsOpen) {
					$scope.selectedObject = wtObject;
				}
			}
			$scope.$apply();
		});

		$scope.$on('launchProjectEditor', function (e, data) {
			if($routeParams['project']) {
				Dialog.openProjectEditor($rootScope.workingFolder);
			} else {
				Dialog.openProjectEditor(data.payload);
			}			
		});

		$scope.$on('refreshProjectView', () => {
			$scope.$broadcast('reloadGrid');
		})

		$scope.$on('launchLegacyDialog', function (e, data) {

			const fileIds = _.map($scope.selectedItems, _.partialRight(_.pick, ['ID', 'Name', 'Type']));

			const packageCallback = () => { $scope.$broadcast('reloadGrid'); }

			switch (data.key) {
				case 'download':
					File.download(fileIds, 'download')
					break;
				case 'checkout':
				case 'project-checkout':
					File.download(fileIds, 'checkout', packageCallback)
					break;
				case 'project-checkin':
					window.launchLegacyDialog(data.key, $scope.selectedItems, $rootScope.workingFolder, '', $scope.kendo[$scope.gridName]._data, Auth.getUsername());
					break;
				case 'checkout-sync':
					File.download(fileIds, 'checkout', packageCallback, false, true, $rootScope.workingFolder)
					break;
				case 'undocheckout':
				case 'project-undocheckout':
					File.undoCheckout(fileIds, false, packageCallback);
					break;
				case 'quickapprovalworkflow':
					const modalOptions = {
						title: 'Quick Approval Workflow',
						maskClosable: false,
						footer: null
					}
					$ngRedux.dispatch(actions.showModal('QUICK_APPROVAL_WORKFLOW', modalOptions, { selectedItems: $scope.selectedItems }));
					break;
				case 'preview':

					let previewObject = {
						id: fileIds[0].ID,
						version: fileIds[0].Version,
						minor: fileIds[0].Minor
					}

					$scope.$emit('loadObjectPreview', previewObject);
					break;
				case 'bravahtml':
				case 'updateprofile':
					window.launchLegacyDialog(data.key, fileIds);
					break;
				default:
					window.launchLegacyDialog(data.key, $scope.selectedItems, $rootScope.workingFolder, '', $scope.kendo[$scope.gridName]._data, Auth.getUsername());
					break;
			}
		});

		$scope.$on('launchFolderDialog', function (e, data) {
			const { key: dialog } = data;
			switch (dialog) {
				case 'project-new':
					Dialog.openNewProject();
					break;
				case 'rename-folder':
					var folderId = $rootScope.workingFolder;

					var pathNode = _.find($scope.breadcrumb, { pathId: folderId });
					let data = { Name: pathNode.breadcrumbName, ID: pathNode.pathId };
		
					$ngRedux.dispatch(actions.showModal('RENAME', { title: 'Rename' }, { dlObject: data }));
					break;
				default:
					window.launchLegacyDialog(dialog, '', $rootScope.workingFolder, '', $scope.kendo[$scope.gridName]._data, Auth.getUsername());
			}
		});

		$scope.$on('openLinkDialog', function (e, data) {
			const directLink = Utility.getLinkURL($scope.selectedItems[0].ID);
			$ngRedux.dispatch(actions.showModal('DIRECT_LINK', {title: 'Link', footer: null, width: 400}, { directLink }));
		});

		$scope.$on('openRenameDialog', function (e, data) {
			$ngRedux.dispatch(actions.showModal('RENAME', { title: 'Rename' }, { dlObject: $scope.selectedItems[0] }));
		});

		$scope.$on('launchProjectDialog', function (e, data) {
			
			let { key, action, payload: item } = data;

			if ($scope.selectedItems[0]) {
				item = $scope.selectedItems[0].ID;
			}

			switch (key) {
				case 'project-getlatest':
					File.download([{ ID: item }], 'download', null, true);
					break;
				case 'project-checkout':
					File.download([{ ID: item }], 'checkout', () => $scope.$broadcast('reloadGrid'), true);
					break;
				case 'project-checkin':
					Project.getFileList(item).promise.then(function (response) {
						let fileList = response.data;
						if (fileList.length === 0) {
							ModalWindow.openNotification('Project contains no files.');
							return false;
						}

						if (!_.includes(_.map(fileList, 'CheckedOutBy'), '<' + Auth.getUsername() + '>')) {
							ModalWindow.openNotification('There are no files currently checked out to you.');
							return false;
						}

						window.launchLegacyDialog('project-checkin', fileList, '', '', '', Auth.getUsername());
					})
					break;
				case 'project-undocheckout':
					File.undoCheckout([{ ID: item }], true, () => $scope.$broadcast('reloadGrid'));
					break;
				case 'download':
					File.projectDownload($scope.selectedItems).then((response) => {
						$ngRedux.dispatch(actions.initiateDownload(response.data.path, false));
					});
					break;
				case 'project-addfile':

					$scope.addFile = function (fileId) {
						Project.addFile(data.payload, fileId).promise.then(function () {
							$scope.selectedId = '';
							$rootScope.$broadcast('refreshProjectView');
						});
					};

					var w = window.screen.availWidth;
					var h = window.screen.availHeight;
					w = (w - 420) / 2;
					h = (h - 440) / 2;

					window.open('legacy/commondialog.aspx?P=1&CurrentFolder=Documents&DialogMode=Open&SourceTable=Objects', "pAddFile", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=500,height=335,top=' + h + ',left=' + w);

					break;
				case 'project-rename':
					var folderId = item;

					let projectData = {};
					var pathNode = _.find($scope.breadcrumb, { pathId: folderId });

					if (pathNode) {
						projectData = { Name: pathNode.breadcrumbName, ID: pathNode.pathId };
					}
					else {
						let selectedProject = _.find($scope.kendo[$scope.gridName]._data, function (ds) { return ds.ID === folderId; });
						projectData = { Name: selectedProject.ProjectName, ID: selectedProject.ID };
					}

					$ngRedux.dispatch(actions.showModal('RENAME', { title: 'Rename' }, { dlObject: projectData }));
	
					break;
				default:					
						window.launchLegacyDialog(data, null, '', '', '', Auth.getUsername());
					break;
			}
		});

		$scope.menuOptions = [];
		$scope.folderMenuOptions = [];
		$scope.selectedItems = [];

		$scope.$on('selectedItemsUpdated', function (e, selectedItems) {
			
				$scope.selectedItems = selectedItems;

				if (selectedItems.length === 0) { $scope.closeDetailsPane(); }

				if ($scope.selectedId !== '' && $scope.detailsPaneIsOpen) {
					if (!_.includes(_.map(selectedItems, 'ID'), GridTools.getObjectFromGrid($scope.selectedId, $scope.kendo[$scope.gridName]._data).ID)) {
						if ($scope.detailsPaneIsOpen) {
							var last = _.last(selectedItems).ID;
							var o = _.find($scope.kendo[$scope.gridName]._data, function (ds) { return ds.ID === last; });
							$scope.selectedId = o.uid;
							$scope.$broadcast('populateDetails', o.uid);
						}
					}
				}

				if ($routeParams.project) {
					if (selectedItems.length > 0) {
						$scope.menuOptions = MenuBuilder.getFileContextMenu(selectedItems, $scope.kendo[$scope.gridName]._data, 'projects');
					} else {
						$scope.menuOptions = MenuBuilder.getProjectContextMenu([{ ID: $routeParams.project }]);
					}
				} else {
					if (selectedItems.length > 0) {
						$scope.menuOptions = MenuBuilder.getProjectContextMenu($scope.selectedItems);
					} else {
						$scope.menuOptions = MenuBuilder.getProjectFolderMenu();
					}					
				}
		});

		$scope.populateFolderMenu = function () {
			$scope.$apply(() => {
				if ($routeParams.project) {
					$scope.menuOptions = MenuBuilder.getProjectContextMenu([{ ID: $routeParams.project }]);
				} else {
					if ($scope.selectedItems.length > 0) {
						$scope.menuOptions = MenuBuilder.getProjectContextMenu($scope.selectedItems);
					} else {
						$scope.menuOptions = MenuBuilder.getProjectFolderMenu();
					}
				}
			})
		}

		$scope.userView = function () { return Columns.isUserView(); };

		$scope.resetColumns = function () {
			$scope.$broadcast('hideGrid');
			Columns.resetColumns($rootScope.workingFolder, function () { $scope.selectedId = ''; $scope.$broadcast('reloadGrid'); });
		};

		$scope.$on('gridLoaded', function (e) {
			$scope.populateFolderMenu();
		});

		$scope.$on('breadcrumbClicked', function (e, data) {
			$location.search({ folder: data.id, page: 1 });
		});

		$scope.closeDetailsPane = function () {
			if ($scope.detailsPaneIsOpen) { angular.element('#details-pane').css({ 'margin-right': '-350px' }) }
			$scope.detailsPaneIsOpen = false;
			$scope.$broadcast('detailsPaneClosed');
		};

		$scope.$on('openConfirmation', function (e, data) {

			const { key } = data;

			if (key === 'project-newversion') {
				ModalWindow.openConfirmation('Increment the project version for the selected project?', function () {
					var item = $routeParams.project ? $rootScope.workingFolder : $scope.selectedItems[0].ID;
					Project.createNewVersion(item).then(function () { $scope.selectedId = ''; $scope.$broadcast('reloadGrid'); });
				});
			}
			if (key === 'project-delete') {
				ModalWindow.openConfirmation('Delete selected project?', function () {
					var item = $routeParams.project ? $rootScope.workingFolder : $scope.selectedItems[0].ID;
					Project.deleteProject(item).promise.then(function () {

						if ($routeParams.project) {
							$location.search({ folder: "Projects", page: 1 });
						} else {
							$scope.selectedId = '';
							$scope.$broadcast('reloadGrid');
						}
					});
				});
			}
			if (key === 'project-removefile') {
				ModalWindow.openConfirmation('Remove selected file(s) from project?', function () {
					Project.removeFile($rootScope.workingFolder, _.map($scope.selectedItems, 'ID')).promise.then(function () {
						$scope.selectedId = '';
						$scope.$broadcast('reloadGrid');
					});
				});
			}
		});

		$scope.closeDialog = function () {
			$scope.selectedId = '';
			$rootScope.$broadcast('reloadGrid');
		};
	}
])

angular.module('webTools').service('Project', ['$q', '$http',
	function ($q, $http) {
		return {
			getFileList: function (projectId) {

				var promise = $q.defer();

				$http.get('/api/projects/getfilelist/?projectId=' + projectId)
					.then(function (data) {
						promise.resolve(data);
					})

				return promise;
			},

			addFile: function (projectId, fileId) {
				var promise = $q.defer();
				$http.get('/api/projects/addfile/', { params: { 'projectId': projectId, 'fileId': fileId } })
					.then(function (res) {
						res.data === '' ? promise.resolve(res.data) : alert(res.data);
					})

				return promise;
			},
			removeFile: function (projectId, fileId) {

				var promise = $q.defer();
				$http.post('/api/projects/removefile/', { ProjectId: projectId, Files: fileId })
					.then(function (data) {
						promise.resolve(data);
					})

				return promise;
			},
			deleteProject: function (projectId) {

				var promise = $q.defer();

				$http.get('/api/projects/deleteproject/?projectId=' + projectId)
					.then(function (data) {
						promise.resolve(data);
					})

				return promise;
			},
			rename: function (objectId, newName) {
				var defer = $q.defer();

				$http.post('/api/projects/rename/', { IsFolder: true, ObjectID: objectId, ObjectType: 'fod', NewName: newName })
					.then(function (data) {
						defer.resolve(data);
					})

				return defer.promise;
			},
			createProject: function (parentFolder, projectName) {
				var defer = $q.defer();

				if (projectName) {
					$http.post('/api/ProjectEditor/CreateProject/', { parentFolder: parentFolder, projectName: projectName })
						.then(function (data) {
							defer.resolve(data);
						}, function (error) { alert(error.data.ExceptionMessage) })
				}
				else {
					alert('Please enter a project name!')
				}

				return defer.promise;
			},
			saveProject: function (projectId, version, name, description, notes) {

				var defer = $q.defer();

				$http.post('/api/ProjectEditor/SaveChanges', { projectId: projectId, versionId: version, name: name, description: description, versionNotes: notes })
					.then(function (data) {
						defer.resolve(data);
					}, err => err.data.ExceptionMessage && alert(err.data.ExceptionMessage))

				return defer.promise;
			},
			getProjectInfo: function (projectId) {

				var defer = $q.defer();

				$http.get('/api/ProjectEditor/GetProjectInfo', { params: { projectId: projectId } })
					.then(function (data) {
						defer.resolve(data);
					})

				return defer.promise;
			},
			getVersionInfo: function (projectId, version) {
				var defer = $q.defer();

				$http.get('/api/ProjectEditor/GetVersionInfo', { params: { projectId: projectId, version: version } })
					.then(function (data) {
						defer.resolve(data);
					})

				return defer.promise;
			},
			createNewVersion: function (projectId) {
				var defer = $q.defer();

				$http.get('/api/projects/createnewversion?projectId=' + projectId)
					.then(function (data) {
						defer.resolve(data);
					})

				return defer.promise;
			},
			deleteVersion: function (projectId, versionId) {

				var defer = $q.defer();

				$http.post('/api/ProjectEditor/DeleteVersion/', { 'projectId': projectId, 'versionId': versionId })
					.then(function (data) {
						defer.resolve(data);
					})

				return defer.promise;
			},
			addVersionFile: function (projectId, versionId, files) {

				var defer = $q.defer();

				$http.post('/api/ProjectEditor/AddFile/', { 'projectId': projectId, 'versionId': versionId, 'files': files })
					.then(function (data) {
						defer.resolve(data);
					})

				return defer.promise;
			},
			removeVersionFile: function (projectId, versionId, files) {

				var defer = $q.defer();

				$http.post('/api/ProjectEditor/RemoveFile/', { 'projectId': projectId, 'versionId': versionId, 'files': files })
					.then(function (data) {
						defer.resolve(data);
					})

				return defer.promise;
			}
		}
	}
]);